import { HTMLAttributes } from 'react'

import Breadcrumbs from '@/components/base/Breadcrumbs'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Section from '@/components/base/Section'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPYoastGraph } from '@/types'

export type HeroProps = HTMLAttributes<HTMLElement> &
  Partial<{
    has_breadcrumb: boolean
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    title: string
    breadcrumbs: WPYoastGraph[]
    align: 'left' | 'center' | 'right'
  }>

const HeroTitle = ({
  title,
  title_variant,
  title_component,
  has_breadcrumb,
  breadcrumbs,
  align,
  className,
  ...props
}: HeroProps) => {
  return (
    <Section className={cn([className])} {...props}>
      <Container className="pt-[2rem] md:pt-[4.5rem]">
        <Grid className="gap-y-gutter">
          {has_breadcrumb ? (
            <div
              className={cn([
                'col-span-4 md:col-span-6 lg:col-span-12',
                'group-[.modal]:hidden'
              ])}
            >
              <Breadcrumbs
                schema={breadcrumbs}
                className={cn([
                  'flex items-center space-x-[.3rem]',
                  {
                    'md:justify-center': align === 'center',
                    'md:justify-end': align === 'right'
                  }
                ])}
              />
            </div>
          ) : null}

          {title ? (
            <div
              className={cn([
                'col-span-4 md:col-span-4 lg:lg:col-span-6',
                'md:group-[.modal]:col-span-6 lg:group-[.modal]:col-span-12',
                {
                  'md:col-start-2 lg:col-start-4': align === 'center',
                  'md:col-start-3 lg:col-start-7': align === 'right'
                }
              ])}
            >
              <Typography
                variant={title_variant}
                component={title_component}
                className={cn([
                  {
                    'md:text-center': align === 'center',
                    'md:text-right': align === 'right'
                  }
                ])}
              >
                {title}
              </Typography>
            </div>
          ) : null}
        </Grid>
      </Container>
    </Section>
  )
}

export default HeroTitle
